import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const initGA = () => {
  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://www.googletagmanager.com/gtag/js?id=G-8BN10Q5TNQ';
  document.head.appendChild(script);

  script.onload = () => {
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    gtag('js', new Date());
    gtag('config', 'G-8BN10Q5TNQ');
    window.gtag = gtag;
  };
};

export const useAnalytics = () => {
  const location = useLocation();
  
  useEffect(() => {
    if (typeof window.gtag !== 'undefined') {
      window.gtag('config', 'G-8BN10Q5TNQ', {
        page_path: location.pathname + location.search,
      });
    }
  }, [location]);
};